<template>
  <b-card no-body>
    <b-row>
      <b-col md="9" class="my-1">
        <h3 slot="header" class="text-center">
          <!--设备名称-->
          <!--                    <span class="text-primary">{{`${inspectionScheduleEquipmentVo.bdaCode} | ${inspectionScheduleEquipmentVo.emArchBasicDataName} | ${inspectionScheduleEquipmentVo.bdaSpecification} | ${inspectionScheduleEquipmentVo.bdaModel}`}}</span>-->
          <span class="text-primary">{{ cardName }}</span>
          <span class="text-black-50">（{{ equStatus }}）</span>
        </h3>
      </b-col>
      <b-col md="3" class="my-1 text-align:right">
        <b-button variant="link" @click="handleShowChangeEquAlert">[变更状态]</b-button>
        <b-button variant="link" @click="handleShowDetailClick">[详情]</b-button>
      </b-col>
    </b-row>
    <div id="itemsResultTable" class="content">
      <div class="card my-1">
        <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
        >
          <div class="bs-component"></div>
          <b-table
              striped
              hover
              responsive
              caption-top
              :items="inspectionScheduleEquipmentVo.inspectionScheduleDetailVoList"
              :fields="fields"
              show-empty
              stacked="md"
          >
            <!--todo：这里可以改成从对象中取variant的数据，然后后端数据库中也存一个variant字段，直接拿他来赋值-->
            <!--点检结果-->
            <template v-slot:cell(inspectionRecordVo.inspectionResultName)="data">
              <b-button-group>
                <b-button block
                          v-if="data.item.inspectionRecordVo && data.item.inspectionRecordVo.inspectionResultName === '正常'"
                          variant="success">{{ data.item.inspectionRecordVo.inspectionResultName }}
                </b-button>
                <b-button block v-else-if="data.item.inspectionRecordVo"
                          :variant="data.item.inspectionRecordVo.inspectionResultName === '报警' ? 'danger' : 'warning'">
                  {{ data.item.inspectionRecordVo.inspectionResultName }}
                </b-button>
                <!--                                查看点检结果时，未录入记录的都视为正常-->
                <b-button block v-if="!data.item.inspectionRecordVo && !enableEdit"
                          variant="success">正常
                </b-button>
                <!--                                <EmPopoverShow-->
                <!--                                        v-else-->
                <!--                                        :id="'emPopoverShow-'+inspectionScheduleEquipmentVo.id+'-'+data.inspectionRecordVo.id"-->
                <!--                                        v-bind:popoverDatas="row.inspectionRecordVo.abnormalDescription"-->
                <!--                                        :buttonName="row.inspectionRecordVo.inspectionResultName"-->
                <!--                                        :variant="row.inspectionRecordVo.inspectionResultName == '异常' ? 'danger' : 'warning'"-->
                <!--                                        :title="row.name.点检项目名"-->
                <!--                                ></EmPopoverShow>-->
              </b-button-group>
            </template>
            <!--异常工单处理状态-->
            <template v-slot:cell(inspectionRecordVo.abnormalStatus)="data" v-if="!enableEdit">
              <b-button-group>
                <!--                                <EmPopoverShow-->
                <!--                                        v-if="data.inspectionRecordVo.abnormalStatus =='已处理'"-->
                <!--                                        :id="'emPopoverShowStatus-'+localData.id+'-'+row.item.序号"-->
                <!--                                        v-bind:popoverDatas="row.item.处理方式"-->
                <!--                                        :buttonName="row.item.异常状态"-->
                <!--                                        variant="success"-->
                <!--                                        :title="row.item.点检项目名"-->
                <!--                                ></EmPopoverShow>-->
                <b-button block
                          v-if="data.item.inspectionRecordVo && data.item.inspectionRecordVo.processStatusName ==='已处理'"
                          variant="success">{{ data.item.inspectionRecordVo.processStatusName }}
                </b-button>
                <b-button block
                          v-else-if="data.item.inspectionRecordVo && data.item.inspectionRecordVo.processStatusName"
                          variant="warning">{{ data.item.inspectionRecordVo.processStatusName }}
                </b-button>
              </b-button-group>
            </template>
            <template v-slot:cell(actions)="data" v-if="enableEdit">
              <!--新增 -->
              <!--                <em-button v-if="!row.inspectionRecordVo" type="add" @click="handleAddClick(row)"></em-button>-->

              <b-button-group v-if="!data.item.inspectionRecordVo">
                <em-button type="add" class="btn-primary" key="executeCardAdd"
                           @click="handleAddClick(data.item)"></em-button>
              </b-button-group>
              <!--修改 -->
              <b-button-group v-else>
                <em-button type="edit" class="btn-success" key="executeCardEdit"
                           @click="handleEditClick(data.item)" v-if="showFunctionButtons(data.item)"></em-button>
                <em-button type="delete" class="btn-warning" key="executeCardDelete"
                           @click="handleDeleteClick(data.item)" v-if="showFunctionButtons(data.item)"></em-button>
<!--                <b-button variant="outline-danger" v-if="!unFinishAbnormalHiddenButtons(data.item)">异常处理中</b-button>-->
                  <span style="color: #ff0000;font-weight: bold" v-if="!showFunctionButtons(data.item)">{{ data.item.inspectionRecordVo.abnormalDescription }}</span>
                <!--                  <b-button size="sm" variant="outline-warning">撤销</b-button>-->
                <!--                  <InspectionRecordPopover-->
                <!--                    @inputAbnormal="handleInputAbnormal"-->
                <!--                    :id="'EpiPopoverUpdateAbnormal-'+inspectionScheduleEquipmentVo.name+'-'+row.item.序号"-->
                <!--                    v-bind:popoverDatas="row.item"-->
                <!--                    buttonName="修改"-->
                <!--                    variant="outline-primary"-->
                <!--                    :iKey="row.item.序号"-->
                <!--                    :title="inspectionScheduleEquipmentVo.name+'&#45;&#45;'+row.item.点检项目名"-->
                <!--                  ></InspectionRecordPopover>-->
              </b-button-group>
            </template>
          </b-table>

          <!-- Info modal -->
          <!--          <b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>-->
          <!--            <pre>{{ modalInfo.content }}</pre>-->
          <!--          </b-modal>-->

          <b-modal ref="alertChangeEquStatusModal" @ok="changeEquStatus">
            确定要变更设备档案状态吗？
          </b-modal>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>

import EmPopoverShow from "@/components/em/EmPopoverShow";
import EmButton from "@/components/em/EmButton";
import {createHelpers} from "vuex-map-fields";

const {mapFields} = createHelpers({
  getterType: "inspectionRecordForInspection/getField",
  mutationType: "inspectionRecordForInspection/updateField"
});

export default {
  name: "inspectionExecuteCard",
  components: {EmPopoverShow, EmButton},
  props: {
    inspectionScheduleEquipmentVo: {
      type: Object,
      required: true
    },
    fields: {
      type: Array
    },
    detailFields: {
      type: Array
    },
    enableEdit: {
      type: Boolean,
      defaultValue: false
    }
  },
  data: function () {
    return {
      popoverId: "1",
      popoverData: {},
      currentPage: 1,
      perPage: 20,
      totalRows: 20,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      modalInfo: {title: "", content: ""},
      equStatus: this.inspectionScheduleEquipmentVo.inspectionScheduleDetailVoList[0].equipmentCurrentStatus
    };
  },
  computed: {
    cardName() {
      return `${this.inspectionScheduleEquipmentVo.emArchBasicDataName}
      | ${this.inspectionScheduleEquipmentVo.bdaSpecification ? this.inspectionScheduleEquipmentVo.bdaSpecification : ""}
      | ${this.inspectionScheduleEquipmentVo.bdaModel ? this.inspectionScheduleEquipmentVo.bdaModel : ""}`
    },
    ...mapFields({
      baseModuleUrl: "baseModuleUrl",
      crudState: 'crudState',
      vuexEntity: "entity",
      taskPathType: 'taskPathType',
    }),
      showFunctionButtons() {
          return (item) => {
              if(item.inspectionRecordVo.abnormalDescription !== undefined &&
                  item.inspectionRecordVo.abnormalDescription !== null &&
                  item.inspectionRecordVo.abnormalDescription !== "") {
                  return item.inspectionRecordVo &&
                      item.inspectionRecordVo.abnormalDescription &&
                      !item.inspectionRecordVo.abnormalDescription.includes('(异常处理中)');
              }
              else{
                  return true;
              }
          }
      }
  },
  methods: {
    //显示设备点检详情
    handleShowDetailClick: function () {
      this.$emit("showDetail", this.inspectionScheduleEquipmentVo);
    },
    //显示设备变更提示框
    handleShowChangeEquAlert() {
      //显示modal
      this.$refs['alertChangeEquStatusModal'].show()
    },
    //设备卡片变更设备状态
    changeEquStatus() {
      //从传过来的parm里取设备编码：this.inspectionScheduleEquipmentVo.emArchBasicDataCode
      this.equStatus = "";
      //用post方法修改，获取返回值
      //如果 在用<->备用 互换状态，其它状态不动
      let url = this.baseModuleUrl + "/doInspection/changeEquipmentStatus";

      this.$store.dispatch("api/post", {
        url,
        data: {bdaCode: this.inspectionScheduleEquipmentVo.emArchBasicDataCode}
      }).then(res => {
        this.equStatus = res.data
      })
    },
    //新增点检记录
    handleAddClick(inspectionScheduleDetailVo) {
      this.$emit("addRecord", inspectionScheduleDetailVo);
    },
    //修改点检记录
    handleEditClick(inspectionScheduleDetailVo) {
      this.$emit("editRecord", inspectionScheduleDetailVo);
    },
    //删除点检记录
    handleDeleteClick(inspectionScheduleDetailVo) {
      this.$emit("deleteRecord", inspectionScheduleDetailVo);
    },
    // getDetail(item) {
    //   return {
    //     点检内容: item.点检内容,
    //     点检标准: item.点检标准,
    //     设备选定状态: item.设备选定状态,
    //     点检方法: item.点检方法,
    //     异常备注: item.异常备注
    //   };
    // },
    getBtnId(item) {
      return item.序号 + "-btn";
    }
    //todo:research how to get the arry_object's sub item
    // handleInputAbnormal(ikey,status, comment) {
    //   alert(ikey+status+comment+'-'+this.localData.toString())
    //   for (var i = 0; i < this.localData.length; i++) {
    //     alert(this.localData[i].序号)
    //   }
    // }
  }
  /* mounted: function() {
    var me = this;
    var urlMod = this.baseApiUrl + "adm-service/adm/module/findByUser/";
    axios({
      method: "get",
      url: urlMod + this.userId
      //USE IN DEVELOPMENT
      //url: "http://localhost:6662/adm-service/adm/module/findByUser/1"
    }).then(json => {
      me.modules = json.data;
    });
  } */
};
</script>
